module.exports = __webpack_public_path__ + "4ead817d4c384f8f46727bb50097a6e4.svg";